import { z } from "zod";

export const financialsTable = z
  .object({
    textAlignment: z
      .union([z.literal("LEFT"), z.literal("CENTER"), z.literal("RIGHT")])
      .describe("The text alignment of the table cells")
      .optional(),
    sortDirection: z
      .union([z.literal("ASC"), z.literal("DESC")])
      .describe("The sort direction of the table")
      .optional(),
    fullBleed: z.boolean().describe("Always show the table with full width").default(false).optional(),
    defaultTemplates: z
      .array(
        z.object({
          objectId: z.string().startsWith("ftemp"),
          vertical: z.union([
            z.literal("ACOES"),
            z.literal("FIIS"),
            z.literal("REITS"),
            z.literal("STOCKS"),
            z.literal("ALL"),
          ]),
          templateCodes: z
            .array(
              z.union([
                z.literal("NORMAL"),
                z.literal("MINING"),
                z.literal("INSURANCE"),
                z.literal("BANK"),
                z.literal("UTILITY"),
                z.literal("TRANSPORT"),
              ]),
            )
            .min(1)
            .max(6),
        }),
      )
      // 1 for FIIs
      // 3 for Ações (Normal, Banks & Insurers)
      // 3 for Stocks (Normal, Banks & Insurers)
      // 1 for REITs (Normal, Banks)
      .min(0)
      .max(8)
      .default([])
      .describe(`The User's default templates for each vertical. It can be at most 8 based on the rules above`)
      .optional(),
    statementType: z
      .union([z.literal("ANNUAL"), z.literal("QUARTERLY")])
      .default("ANNUAL")
      .describe("The statement type for the table")
      .optional(),
    indicatorDataSource: z
      .union([z.literal("MORNINGSTAR"), z.literal("CVM")])
      .default("CVM")
      .describe("The data source for the indicators")
      .optional(),
  })
  .default({
    sortDirection: "ASC",
    textAlignment: "CENTER",
    fullBleed: false,
    defaultTemplates: [],
    statementType: "ANNUAL",
    indicatorDataSource: "CVM",
  });
